// components/EmailTemplates/EmailTemplateHeader.js
import React from "react";
import {Button, Heading, HStack, Icon, IconButton, Tooltip,} from "@chakra-ui/react";
import {FiArrowLeft, FiMail, FiPlus, FiRefreshCw,} from "react-icons/fi";

const EmailTemplateHeader = ({
                                 onGoBack,
                                 onRefresh,
                                 onCreateTemplate,
                             }) => {
    return (
        <HStack spacing={2} justify="space-between" mb={6} flexWrap="wrap" gap={4}>
            <HStack spacing={2}>
                <IconButton
                    icon={<FiArrowLeft/>}
                    variant="ghost"
                    onClick={onGoBack}
                    aria-label="Go Back"
                />
                <Icon as={FiMail} w={6} h={6}/>
                <Heading size="lg">Email Templates</Heading>
            </HStack>

            <HStack spacing={2} flexWrap="wrap">
                <Tooltip label="Refresh">
                    <IconButton
                        icon={<FiRefreshCw/>}
                        variant="ghost"
                        onClick={onRefresh}
                        aria-label="Refresh"
                    />
                </Tooltip>
                <Button
                    leftIcon={<FiPlus/>}
                    colorScheme="blue"
                    onClick={onCreateTemplate}
                    size={{ base: "sm", md: "md" }}
                >
                    Create Template
                </Button>
            </HStack>
        </HStack>
    );
};

export default EmailTemplateHeader;
